import React from 'react';

import Fab from 'xgimi-ui/mui/material/Fab';
import Base from 'xgimi-ui/BaseComponent';
import Icon, { icons } from 'xgimi-ui/Icon';

import s from './.module.scss';

interface Props {
  // 滚动到底部
  onScrollBottom?: () => void;
  // 触发滚动
  onScroll?: (scrollTop: number) => void;
  // 滚动的位置
  scrollTop: number;
}

interface State {
  // 是否显示回到顶部按钮
  isShowBackTopButton: boolean;
}

/**
 * 回到顶部
 */
class ScrollTop extends Base<Props, State> {
  state: State = {
    isShowBackTopButton: false,
  };

  // 容器ref
  private containerRef: React.RefObject<HTMLDivElement> = React.createRef();

  // 到底标志位
  private isBottom: boolean = false;

  componentDidMount() {
    this.containerRef.current?.scrollTo?.({ top: this.props.scrollTop });
  }

  /**
   * 触发滚动
   */
  private onScroll = (): void => {
    if (this.containerRef.current?.scrollTop) {
      this.props.onScroll?.(this.containerRef.current?.scrollTop);
      // 是否显示回到顶部的按钮
      this.setState({ isShowBackTopButton: this.containerRef.current?.scrollTop > 100 });
      // 滚动到底部
      if ((this.containerRef.current?.scrollTop + this.containerRef.current?.clientHeight) >= this.containerRef.current?.scrollHeight) {
        // 第一次滚动到底部时才触发
        if (!this.isBottom) {
          this.isBottom = true;
          this.props.onScrollBottom?.();
        }
      } else {
        this.isBottom = false;
      }
    }
  };

  /**
   * 回到顶部
   */
  private onTop = (): void => {
    this.setState({ isShowBackTopButton: false });
    this.containerRef.current?.scrollTo?.({ top: 0 });
  };

  render(): React.ReactNode {
    return (
      <div
        className={this.getClassName(s.container)}
        onScroll={this.onScroll}
      >
        <div ref={this.containerRef} className={s.content}>
          {this.props.children}
        </div>

        {/* 回到顶部按钮 */}
        {this.state.isShowBackTopButton && (
          <Fab
            className={s.top}
            color="default"
            size="small"
            onClick={this.onTop}
          >
            <Icon type={icons.VerticalAlignTop} />
          </Fab>
        )}
      </div>
    );
  }
}

export default ScrollTop;
